<app-warning [focus]="true">
  <div>
    <p class="h5">
      <strong>Error Message</strong>
    </p>
    <br>
    <p *ngIf="displayStudentEligiblityError" class="h6">You are not eligible to purchase student software.</p>
    <p *ngIf="displayLicenseErrors.student || displayLicenseErrors.employee || displayLicenseErrors.university"
       class="h6">
      You may not combine university and personal licenses in the same shopping cart.
    </p>
  </div>
</app-warning>
